import {
  anonymousClient,
  emailOTPClient,
  genericOAuthClient,
  inferAdditionalFields,
  lastLoginMethodClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { Auth } from "@/lib/auth";

function getAuthBaseUrl() {
  if (typeof window !== "undefined") {
    return new URL("/api/better-auth", window.location.origin).href;
  }

  return process.env.NEXT_PUBLIC_BASE_URL
    ? new URL("/api/better-auth", process.env.NEXT_PUBLIC_BASE_URL).href
    : "http://localhost:3000/api/better-auth";
}

export const authClient = createAuthClient({
  baseURL: getAuthBaseUrl(),
  plugins: [
    inferAdditionalFields<Auth>(),
    emailOTPClient(),
    genericOAuthClient(),
    lastLoginMethodClient(),
    anonymousClient(),
  ],
});

export async function signOut() {
  await authClient.signOut();
  window.location.href = "/login";
}
